var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: _vm.width,
        "close-on-click-modal": false,
        "destroy-on-close": _vm.destroyOnClose
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.open,
        opened: _vm.opened,
        close: _vm.close,
        closed: _vm.closed
      },
      scopedSlots: _vm._u(
        [
          {
            key: "title",
            fn: function() {
              return [
                _c("div", { staticClass: "frame-top-left" }),
                _c("div", { staticClass: "frame-top-right" }),
                _c("div", { staticClass: "dialog-title" }, [
                  _vm._v(" " + _vm._s(_vm.title) + " ")
                ]),
                _vm.existsRequired
                  ? _c("div", { staticClass: "required-description" }, [
                      _c("span", [_vm._v("－必須")])
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "footer-inner" },
                  [_vm._t("footer")],
                  2
                ),
                _c("div", { staticClass: "frame-bottom-left" }),
                _c("div", { staticClass: "frame-bottom-right" })
              ]
            },
            proxy: true
          }
        ],
        null,
        true
      )
    },
    [_vm._t("form")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }